module.exports = "pegasus_template/assets/themecapture1/product/100.png";